import {h} from 'preact'
import css from 'minify-css.macro'
import {styles} from '../styles'

export const ContentHeading: React.FC = ({children}) => (
  <header className={contentHeading()}>{children}</header>
)

export const ContentHeadingBanner: React.FC = ({children}) => (
  <ContentHeading>
    <div className={contentHeadingBanner()}>{children}</div>
  </ContentHeading>
)

const contentHeading = styles.one(
  ({color}) => css`
    display: flex;
    align-items: center;
    min-height: 58px;
    border-bottom: 2px solid ${color['ui/primary']};
  `
)

const contentHeadingBanner = styles.one(
  ({font}) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: ${font.size.content};
    font-family: ${font.family.brand};
    font-weight: 700;
  `
)

interface ContentHeadingContextType {
  children: React.ReactNode
  setChildren: (children: JSX.Element | null) => void
}
